const EU_CONSENT_PREFERENCES_COOKIE = 'cm_eu_preferences';
const DEFAULT_CONSENT_PREFERENCES_COOKIE = 'cm_default_preferences';
const PREFERENCE_EXPIRATION_YEAR = 1;
const TRACKER_CATEGORIES = ['necessary', 'functional', 'performance', 'targeting'];
const MAX_COOKIE_SIZE = 4; // in KB

const REQUIRED_COOKIE_MANAGER_COOKIES = [EU_CONSENT_PREFERENCES_COOKIE, DEFAULT_CONSENT_PREFERENCES_COOKIE];
const GEOLOCATION_RULES = [{
  region: 'DEFAULT',
  framework: 'optOut'
}, {
  region: 'EU',
  framework: 'optIn'
}];
const COOKIE_BANNER_ANIMATION_DURATION_IN_SECONDS = 1;
export { COOKIE_BANNER_ANIMATION_DURATION_IN_SECONDS, DEFAULT_CONSENT_PREFERENCES_COOKIE, EU_CONSENT_PREFERENCES_COOKIE, GEOLOCATION_RULES, MAX_COOKIE_SIZE, PREFERENCE_EXPIRATION_YEAR, REQUIRED_COOKIE_MANAGER_COOKIES, TRACKER_CATEGORIES };
//# sourceMappingURL=constants.js.map
